import shellHttpClient from '@/shells/api/shellHttpClient';
import { normalizeInterfacePreferences, serializePreferencePatch } from '@/shells/models/interfacePreferences';

export class InterfacePreferencesRepository {
  constructor(client = shellHttpClient) {
    this.client = client;
  }

  async get() {
    const response = await this.client.get('/api/v1/users/interface-preferences');
    return normalizeInterfacePreferences(response.data);
  }

  async update(patch) {
    const response = await this.client.put(
      '/api/v1/users/interface-preferences',
      serializePreferencePatch(patch),
      { headers: { 'Content-Type': 'application/json' } }
    );
    return normalizeInterfacePreferences(response.data);
  }
}

export const interfacePreferencesRepository = new InterfacePreferencesRepository();
